// eslint-disable-next-line no-shadow
export enum RatingType {
    Driver,
    Trailer
}
